import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Edit_Testslist = () => {
  const { id } = useParams(); // Get test ID from URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    test_name: "",
    test_code: "",
    test_id: "",
    test_category: "",
    tc_id: "" // Updated to match API response
  });

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [catList, setCategoryList] = useState([]);

  // Fetch categories list
  useEffect(() => {
    const token = localStorage.getItem("jwt_token");
    fetch(`${API_BASE_URL}api/getCategoriesList`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data.data)) {
          setCategoryList(data.data);
        } else {
          console.error("Data is not an array:", data);
          setCategoryList([]);
        }
      })
      .catch(error => console.error("Error:", error));
  }, []);

  // Fetch test details by ID
  useEffect(() => {
    if (!id) return;
    
    const token = localStorage.getItem("jwt_token");
    fetch(`${API_BASE_URL}api/getTestById?test_id=${id}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.STATUS && data.data.length > 0) {
          const testDetails = data.data[0]; // Extract first item from array
          setFormData({
            test_name: testDetails.test_name,
            test_code: testDetails.test_code,
            test_id: testDetails.test_id,
            test_category: testDetails.test_category,
            tc_id: testDetails.tc_id // Store correct category ID
          });
          setErrorMessage(""); // Clear error message if data loads successfully
        } 
        // else {
        //   setErrorMessage("Failed to load test details.");
        // }
      })
      .catch(error => {
        console.error("Error fetching test:", error);
        setErrorMessage("Failed to load test.");
      });
  }, [id]);

  // Handle input change
 const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};

  // Handle form submission (Update test)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const payload = {
      test_id: id,
      test_name: formData.test_name,
      test_code: formData.test_code,
      tc_id: formData.tc_id, // ✅ Include category ID explicitly
    };
      const response = await fetch(`${API_BASE_URL}api/updateTest/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`, // Include JWT token if required
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to update test");
      }

      const data = await response.json();
      console.log("Success:", data);

      setShowSnackbar(true);

      setTimeout(() => {
        setShowSnackbar(false);
        navigate(-1); // Navigate back after update
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Failed to update test. Please try again.");
    }
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page">
        <div className="position-relative">
          <Navbar />
        </div>
        <div className="content-inner container-fluid pb-0" id="page_layout">
          {showSnackbar && (
            <div className="snackbar">
              <p>Test updated successfully!</p>
            </div>
          )}

          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">Edit Test</h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="new-user-info">
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label htmlFor="test_name">Test Name:</label>
                          <input
                            type="text"
                            className="form-control form-control-sm my-2"
                            id="test_name"
                            name="test_name"
                            value={formData.test_name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <div className="form-group col-md-6">
                          <label htmlFor="test_code">Test Code:</label>
                          <input
                            type="text"
                            className="form-control form-control-sm my-2"
                            id="test_code"
                            name="test_code"
                            value={formData.test_code}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <div className="form-group col-md-6">
                          <label htmlFor="test_category">Mapped Test Category:</label>
                          <select
  className="form-control form-control-sm my-2"
  id="tc_id"
  name="tc_id"
  value={formData.id}
  onChange={handleInputChange}
  required
>
  <option value="">Select a category</option>
  {catList.map((cat) => (
    <option key={cat.id} value={cat.id}>
      {cat.test_category}
    </option>
  ))}
</select>

                        </div>

                        <div className="form-group col-md-6">
                          <label htmlFor="test_id">Service Id:</label>
                          <input
                            type="text"
                            className="form-control form-control-sm my-2"
                            id="test_id"
                            name="test_id"
                            value={formData.test_id}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-danger-subtle"
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-sm btn-primary-subtle">
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Edit_Testslist;
